import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import { useSetRecoilState } from "recoil";
import { loadingState } from "../recoil/atoms/loading";
import {alert, confirm} from "../components/MegConfirmAlert";

export const useAxios = () => {
  const setLoading = useSetRecoilState(loadingState); // 로딩 상태를 전역적으로 관리

  // 요청 핸들러
  const requestHandler = (config) => {    
    setLoading(true); // 로딩 시작
    const accessToken = localStorage.getItem("accessToken");
    if(accessToken){
      config.headers.Authorization = accessToken;
    }    
    return config;
  };

  // 응답 핸들러
  const responseHandler = (response) => {
    setLoading(false); // 로딩을 멈춰야 함
    return response;
  };

  // 에러 핸들러
  const errorHandler = async (error) => {
    const errorResult = {
      data : {}
    }
    setLoading(false); // 로딩을 멈춰야 함
    if (error.response) {
      // 요청이 전송되었고, 서버는 2xx 외의 상태 코드로 응답했습니다.
      if(error.response.data.resultCode === 1001){

        console.log("TOKEN ERROR");
        
        const refreshToken = localStorage.getItem("refreshToken");

        localStorage.setItem("accessToken", "");
        localStorage.setItem("refreshToken", "");

        const response = await request.post("/app/refreshToken", refreshToken);
        if(response.data.resultCode === 200){
            localStorage.setItem("accessToken", response.data.result.token.accessToken);
            localStorage.setItem("refreshToken", response.data.result.token.refreshToken);         
            error.config.headers.Authorization = localStorage.getItem("accessToken");
            console.log("TOKEN REFRESH");
            return request(error.config);
        }else{
          localStorage.removeItem("user");
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");          
        }        
      }      
      errorResult.data= error.response.data;
    } else if (error.request) {
      // 요청이 전송되었지만, 응답이 수신되지 않았습니다. 
      // 'error.request'는 브라우저에서 XMLHtpRequest 인스턴스이고,
      // node.js에서는 http.ClientRequest 인스턴스입니다.
      console.log(error.request);
    } else {
      // 오류가 발생한 요청을 설정하는 동안 문제가 발생했습니다.
      console.log('Error', error.message);
    }
    console.log(error.config);
    alert('서버 오류 발생. 관리자에게 문의바랍니다.');
    return errorResult;
  };

  const request = axios.create({
    baseURL: "https://www.salee.co.kr/",
    timeout: 5000,
  });

  request.interceptors.request.use(
    (config) => requestHandler(config),
    (e) => errorHandler(e)
  );

  request.interceptors.response.use(
    (response) => responseHandler(response),
    (e) =>  errorHandler(e)
  );

  return [request];
};